<template>
  <section id="page-contact" class="py-5 light-section">
    <div class="intro-text text-center mb-5">
      <h2>Kontakt</h2>
      <p>Wir freuen uns auf Ihre Nachricht! Egal ob Projektidee, kritischer Kommentar oder allgemeine Frage.</p>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div
            class="col-md-6 col-lg-3 mb-4 slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm h-100 hover-card">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-start mb-3">
                <div class="icon-container d-flex justify-content-center align-items-center">
                  <i class="fas fa-envelope icon"></i>
                </div>
              </div>
              <h3 class="card-title">E-Mail</h3>
              <p class="card-text flex-grow-1 text-center">Schnell und unkompliziert.<br>Sie schreiben - wir antworten innerhalb eines Tages.</p>
              <a href="mailto:info@crafting-systems.de" class="btn btn-primary btn-lg mt-2">
                E-Mail senden
                <i class="fas fa-envelope"></i>
              </a>
            </div>
          </div>
        </div>

        <div
            class="col-md-6 col-lg-3 mb-4 slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm h-100 hover-card">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-start mb-3">
                <div class="icon-container d-flex justify-content-center align-items-center">
                  <i class="fas fa-phone icon"></i>
                </div>
              </div>
              <h3 class="card-title">Telefon</h3>
              <p class="card-text flex-grow-1 text-center">Für den direkten Austausch sind wir auch telefonisch erreichbar.</p>
              <a href="tel:+4915162987881" class="btn btn-primary btn-lg mt-2">
                Anrufen
                <i class="fas fa-phone"></i>
              </a>
            </div>
          </div>
        </div>
        <div
            class="col-md-6 col-lg-3 mb-4 slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm h-100 hover-card">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-start mb-3">
                <div class="icon-container d-flex justify-content-center align-items-center">
                  <i class="fab fa-linkedin icon"></i>
                </div>
              </div>
              <h3 class="card-title">LinkedIn</h3>
              <p class="card-text flex-grow-1 text-center">Nachricht schicken oder Crafting Systems folgen</p>
              <a href="https://www.linkedin.com/company/crafting-systems" target="_blank" class="btn btn-primary btn-lg mt-2">
                CS auf LinkedIn
                <i class="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  name: 'ContentContact',
  setup() {
    const imageVisible = ref(false);
    const textVisible = ref(false);
    const cardsVisible = ref(false);

    onMounted(() => {
      setTimeout(() => {
        textVisible.value = true;
        imageVisible.value = true;
        cardsVisible.value = true;
      }, 50); // Delay to trigger the animation after the component is mounted
    });

    return {imageVisible, textVisible, cardsVisible };
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style';

.intro-text h2 {
  font-size: 2.5rem;
  font-weight: bold;
  color: #3a3a3a;
  margin-bottom: 2rem;
  margin-top: 3rem;
}

.intro-text p {
  font-size: 1.2rem;
  color: #3a3a3a;
}
</style>
